module.exports = __webpack_public_path__ + "static/media/logo-serpros.ca85dad0.png";